import * as React from "react";
const SvgDropdown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 5, viewBox: "0 0 12 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 0L5.625 5L11.25 0H0Z", fill: "#05C7DB" }));
export default SvgDropdown;
